import type { EditControlProps } from '../../declare'
import { useState, useEffect, useContext } from 'react'
import { autorun } from 'mobx'
import { Checkbox, Switch } from 'antd'
import { EditContext } from 'src/components'
import { appStore } from 'src/stores'

const CheckboxControl = (props: EditControlProps) => {
  const edit = useContext(EditContext)

  const [options, setOptions] = useState([])
  useEffect(() => autorun(() => {
    const find = edit.editConfig.Nav_PageEdit?.Nav_Enums?.find((item: any) => item.EnumName === props.config.ENUM)
    if (find?.options) {
      setOptions(find.options)
    } else {
      appStore.getEnums([props.config.ENUM]).then((data: any[]) => {
        setOptions(appStore.getEnumOptions(props.config.ENUM, data))
      })
    }
  }), [props.config.ENUM])

  const handleGroupChange = (checkedValue: any[]) => {
    props.onChange?.(checkedValue.join(','))
  }

  const handleSwitchChange = (checked: boolean) => {
    props.onChange?.(checked)
  }

  const { __READONLY__, EDITABLE, ENUM } = props.config
  const disabled = __READONLY__ || !EDITABLE || props.evtConfig?.disabled

  if (ENUM) {
    return (
      <Checkbox.Group
        disabled={disabled}
        value={props.value.split(',')}
        options={options}
        onChange={handleGroupChange}
      />
    )
  }

  return (
    <Switch
      disabled={disabled}
      checked={props.value}
      onChange={handleSwitchChange}
    />
  )
}

export default CheckboxControl
